/**
 * The display id of a program objective (ADR-0078 §11): `CC6.1_obj.3` → `CC6.1-POF-03` (SOC 2),
 * `6.1.2_obj.2` → `6.1.2-OBJ-02` (ISO 42001). Unknown shapes fall back to the ref. A leaf module so
 * the next-gap ranker and the Risk acceptances register (D-106-20) share it without an import cycle.
 */
export function objectiveDisplayLabel(program, ref) {
    const m = /^(.*)_obj(?:\.(\d+))?$/.exec(ref);
    if (!m)
        return ref;
    const [, base, n] = m;
    if (program === 'soc2')
        return n ? `${base}-POF-${n.padStart(2, '0')}` : base;
    if (program === 'iso-42001')
        return n ? `${base}-OBJ-${n.padStart(2, '0')}` : base;
    return ref;
}
//# sourceMappingURL=objective-label.js.map